module.exports = function() {
    var MCAC = {
        Helpers: null,
        shortUrl: null,
        queryString: null,
        subdomain: null,
        cardTemplate: null,
        handlebars: null,
        searchAjax: null
    };

    MCAC.init = function() {
        MCAC.Helpers = {
            Ajax: require('../../../helpers/_ajax')()
        };
        MCAC.Helpers.Ajax.init();
        MCAC.handlebars = require('handlebars');

        MCAC.handlebars.registerHelper('ifvalue', function (conditional, options) {
            if (options.hash.value == conditional) {
                return options.fn(this)
            } else {
                return options.inverse(this);
            }
        });

        MCAC.handlebars.registerHelper('ifvaluenot', function (conditional, options) {
            if (options.hash.value != conditional) {
                return options.fn(this)
            } else {
                return options.inverse(this);
            }
        });

        MCAC.handlebars.registerHelper('ifin', function (conditional, options) {
            if (options.hash.value.split(',').indexOf(conditional) !== -1) {
                return options.fn(this)
            } else {
                return options.inverse(this);
            }
        });

        // Use UI.registerHelper..
        MCAC.handlebars.registerHelper("formatNumberValue", function (val, format) {
            return window.P2A.Helpers.Numbers.formatNumberValue(val);
        });

        //http://stackoverflow.com/a/16315366/761793
        MCAC.handlebars.registerHelper('ifCond', function (v1, operator, v2, options) {
            switch (operator) {
                case '==':
                    return (v1 == v2) ? options.fn(this) : options.inverse(this);
                case '===':
                    return (v1 === v2) ? options.fn(this) : options.inverse(this);
                case '<':
                    return (v1 < v2) ? options.fn(this) : options.inverse(this);
                case '<=':
                    return (v1 <= v2) ? options.fn(this) : options.inverse(this);
                case '>':
                    return (v1 > v2) ? options.fn(this) : options.inverse(this);
                case '>=':
                    return (v1 >= v2) ? options.fn(this) : options.inverse(this);
                case '&&':
                    return (v1 && v2) ? options.fn(this) : options.inverse(this);
                case '||':
                    return (v1 || v2) ? options.fn(this) : options.inverse(this);
                default:
                    return options.inverse(this);
            }
        });

        MCAC.$campaignsContainer = $('#campaigns-container');
        MCAC.$search = $('.search');
        MCAC.$searchSearchContainer = $('.search-search-container', MCAC.$search);
        MCAC.$searchingBox = $('.searching-box', MCAC.$search);
        MCAC.$searchIcon = $('.search-icon', MCAC.$search);
        MCAC.$searchShowing = $('.search-showing', MCAC.$search);
        MCAC.$searchShowingLocation = $('.search-showing-location', MCAC.$searchShowing);
        MCAC.$searchButton = $('.search-button', MCAC.$search);
        MCAC.$searchResetButton = $('.reset-button', MCAC.$search);
        MCAC.$searchShowContainer = $('.search-show-container', MCAC.$search);
        MCAC.$searchShowingContainer = $('.search-showing-container', MCAC.$search);

        $(function() {
            MCAC.$searchingBox.keydown(function(event) {
                if (event.keyCode == 13) {
                    MCAC.$searchButton.trigger('click');
                } else if (
                    // Allow: backspace, delete, tab, escape
                    event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 9 || event.keyCode == 27 ||
                    // Allow: Ctrl and Cmd
                    (event.ctrlKey === true || event.metaKey === true) ||
                    // Allow: home, end, left, right
                    (event.keyCode >= 35 && event.keyCode <= 39)) {
                    // let it happen, don't do anything
                    return true;
                }
                else {
                    // Ensure that it is a number and stop the keypress
                    if (event.shiftKey || (event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105 )) {
                        event.preventDefault();
                    }
                }
            });

            MCAC.$searchButton.click(function() {
                var $me = $(this);
                if (MCAC.validateZipCode(MCAC.$searchingBox.val())) {
                    var searchParams = {
                        zip5: MCAC.$searchingBox.val(),
                        saveCookie: 1
                    };

                    MCAC.$searchingBox.prop('disabled', true);

                    //When the ajax call is returned, show the reset button
                    var onReturn = function() {
                        MCAC.showResetScreen();
                    };
                    MCAC.retrieveActionCenterCampaigns(searchParams, onReturn, $me);
                }
            });
            MCAC.$searchResetButton.click(function() {
                var $me = $(this);

                var onReturn = function() {
                    $me.hide();
                    MCAC.showSearchScreen();
                };
                MCAC.retrieveActionCenterCampaigns(null, onReturn, $me);
            });
        });
    };

    MCAC.showResetScreen = function() {
        MCAC.$searchShowContainer.hide();
        MCAC.$searchShowingContainer.show();
        MCAC.$searchResetButton.show();
    };
    MCAC.showSearchScreen = function() {
        MCAC.$searchingBox.val('');
        MCAC.$searchingBox.prop('disabled', false);
        MCAC.$searchShowContainer.show();
        MCAC.$searchShowingContainer.hide();
    };

    MCAC.validateZipCode = function(zipCode) {
        if (zipCode && zipCode.length === 5) {
            return true;
        }
        return false;
    };

    //Params are just to pass through to retrievecationcentercampaigns again
    MCAC.retrieveHandlebarsTemplate = function(onHandlebarsReturn) {
        $.ajax({
            url: '/js/app/campaigns/actioncenter/campaigncard.js.html',
            type: 'GET',
            dataType: 'html',
            success: function (tpl) {
                MCAC.cardTemplate = MCAC.handlebars.compile(tpl);

                if (typeof onHandlebarsReturn !== 'undefined' && onHandlebarsReturn !== null) {
                    onHandlebarsReturn();
                }
            }
        });
        return true;
    };

    MCAC.retrieveActionCenterCampaigns = function(searchParams, onReturn, $button, firstLoad) {
        if (!searchParams) {
            searchParams = {};
        }

        if (typeof onReturn !== 'function') {
            onReturn = null;
        }

        if ($button) {
            MCAC.Helpers.Ajax.loadingStarted($button);
        }

        var fadeOutTime = 500;
        if (firstLoad === true) {
            fadeOutTime = 1;
        }
        MCAC.$campaignsContainer.fadeOut(fadeOutTime, function() {
            var $me = $(this);
            $me.html('<div class="campaigns-loading"><i class="fa fa-spin fa-spinner"></i></div>');
            $me.show();
            MCAC.hideErrorMessage();

            if (MCAC.cardTemplate === null) {
                var onHandlebarsReturn = function() {
                    MCAC.retrieveActionCenterCampaigns(searchParams, onReturn, $button);
                };
                //The template call will call us (retrieveActionCenterCampaigns) again when it is successful
                MCAC.retrieveHandlebarsTemplate(onHandlebarsReturn);
            } else {
                var uri = '/' + MCAC.shortUrl + '/mcac/campaigns';
                var params = {
                    method: 'GET',
                    data: {
                        subdomain: MCAC.subdomain,
                        queryString: MCAC.queryString
                    }
                };

                params.data = $.extend({}, params.data, searchParams);

                var onSuccess = function (returnData) {
                    //If we were passed a function to call when the cards are loaded, call it now
                    if (onReturn !== null) {
                        onReturn();
                    }

                    MCAC.showCampaigns(returnData);

                    //Ajax has completed
                    MCAC.searchAjax = null;
                    if ($button) {
                        MCAC.Helpers.Ajax.loadingCompleted($button, false);
                    }

                };
                //If we are already searching, cancel the previous search
                if (MCAC.searchAjax !== null) {
                    MCAC.searchAjax.abort();
                }
                MCAC.searchAjax = MCAC.Helpers.Ajax.send(uri, params, onSuccess);
            }
        });
    };

    MCAC.showCampaigns = function(data) {
        if (typeof data.campaigns === 'undefined' || !data.campaigns) {
            MCAC.$campaignsContainer.html('');
            var errorMessage = 'No campaigns were found for ';
            if (data.zipCodeInfo && data.zipCodeInfo.prettyCities) {
                errorMessage += data.zipCodeInfo.prettyCities[0] + '.';
            } else {
                errorMessage += 'your area.';
            }
            errorMessage += ' Please entering a new zip code above.';
            MCAC.showErrorMessage(errorMessage);
            MCAC.showSearchScreen();
            return false;
        } else {
            MCAC.hideErrorMessage();
        }
        var campaigns = data.campaigns;
        var templateCode = '';
        var numOfCampaigns = campaigns.length;
        var campaign = null;
        var rowClosed = false;
        var civicActionCenterCode = $('#tempCivicActionCenterCode').html();

        // Update the total advocate counter, if it is enabled for the campaign
        var mcacAdvocateCounterElement = document.getElementById('mcac-advocate-counter__wrapper');
        if (mcacAdvocateCounterElement && data.advocateCount) {
            // Update the total advocate counter's value
            document.getElementById('mcac-advocate-counter__count').textContent = data.advocateCount;
            mcacAdvocateCounterElement.style.display = 'block'; // Set the counter to be visible
        }

        //Implement the mustache template for each campaign card
        for (var i = 0; i < numOfCampaigns; i++) {
            campaign = campaigns[i];
            templateCode += MCAC.cardTemplate(campaign);
            if (campaign.iterationNumber % 3 === 0 || campaign.featured === 1) {
                templateCode += '</div>';
                rowClosed = true;
            }
        }

        if (rowClosed !== true || civicActionCenterCode.length) {
            templateCode += '</div>';
        }

        //Now add in civic action center campaigns if we have them
        if (civicActionCenterCode.length) {
            templateCode += civicActionCenterCode;
        }

        //Now add in completed campaigns
        campaigns = data.completedCampaigns;
        if (campaigns) {
            numOfCampaigns = campaigns.length;
            campaign = null;
            rowClosed = false;
            if (numOfCampaigns) {
                templateCode += '<div class="row"><div class="completed-campaigns col-sm-12">';
                templateCode += '<hr class="completed-headline">';
            }
            //Implement the mustache template for each campaign card
            for (i = 0; i < numOfCampaigns; i++) {
                campaign = campaigns[i];
                templateCode += MCAC.cardTemplate(campaign);
                if (campaign.iterationNumber % 3 === 0) {
                    templateCode += '</div>';
                    rowClosed = true;
                }
            }
            if (rowClosed !== true) {
                templateCode += '</div>';
            }
            if (numOfCampaigns) {
                templateCode += '   <div class="completed-reset"><a href="/' + MCAC.shortUrl + '?resetCompletedCampaigns=1" class="completed-reset-button">Reset completed campaigns</a></div>';
                //Close completed-campaigns
                templateCode += '</div></div>';
            }
        }

        MCAC.$campaignsContainer.html(templateCode);

        if (data.zipCodeInfo && data.zipCodeInfo.prettyCities) {
            MCAC.$searchShowingLocation.html('ZIP: ' + data.zipCodeInfo.zipCode);
            MCAC.$searchShowContainer.hide();
            MCAC.$searchShowingContainer.show();
        }

        // Listen on share button click
        $('#campaigns-container').on('click', '.sharelink', function (e) {
            e.preventDefault();
            var id = $(this).attr('data-id');
            $(this).hide();
            $('#share-' + id).show();
        });
    };

    MCAC.showErrorMessage = function(errorMessage) {
        var $alertContainer = $('#mcac-alert-container .alert-container');
        if ($('.alert-danger', $alertContainer).length <= 0) {
            var message = '<div class="alert alert-danger" style="display: none;"><i class="fa fa-warning"></i> ';
            message += errorMessage;
            message += '</div>';

            $alertContainer.prepend(message);
            //Ease it in
            $('.alert-danger', $alertContainer).show(function() {
                var $me = $(this);
                $('html, body').animate({
                    scrollTop: $me.offset().top
                }, 400);
            });
        } else {
            $('.alert-danger', $alertContainer).html('<i class="fa fa-warning"></i> ' + errorMessage);
            //Ease it in
            $('.alert-danger', $alertContainer).show(function() {
                var $me = $(this);
                $('html, body').animate({
                    scrollTop: $me.offset().top
                }, 400);
            });
        }
    };

    MCAC.hideErrorMessage = function() {
        var $alertContainer = $('#mcac-alert-container .alert-container');
        var $alertDanger = $('.alert-danger', $alertContainer);
        $alertDanger.html('');
        $alertDanger.hide();
    };

    return MCAC;
};
